import { request, requestFile } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function getlistDoc(dispatch,id) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/archivo/find/evbi/${id}`,
		method: "GET",
	}, dispatch);
}

export function createDocumento(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/archivo/registrar`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function deleteDocumento(dispatch, id) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/archivo/eliminar/${id}`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	}, dispatch);
}

export function loadFile(dispatch, nameBascula, formData) {
	let url = `${process.env.REACT_APP_API_EVBI}/files?doc=DOCUMENTOS_BASCULAS/${nameBascula}`;
	return requestFile({ 
		url: url,
		method: "POST",
		body: formData,
	}, dispatch);
}

export function loadMantenimientos(dispatch, nameBascula, formData) {
	let url = `${process.env.REACT_APP_API_EVBI}/files?doc=MANTENIMIENTOS_BASCULAS/${nameBascula}`;
	return requestFile({ 
		url: url,
		method: "POST",
		body: formData,
	}, dispatch);
}